import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { values } from 'lodash'
import { connect } from 'react-redux'

import Post from './post'
import { fetchPosts, maybeFetchPosts } from '../actions'
import { getPosts } from '../reducers'

class PostWrapper extends Component {
  componentDidMount() {
    if (values(this.props.posts).length === 1) {
      this.props.fetchPosts({ excludeBody: true })
    }
    this.props.maybeFetchPosts([this.props.params.slug])
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.slug !== prevProps.params.slug) {
      this.props.maybeFetchPosts([this.props.params.slug])
    }
  }

  componentWillUnmount() {
    ReactRailsUJS.unmountComponents('.ujs-mount-point')
  }

  render() {
    return (
      <Post
        key={this.props.params.slug}
        postSlug={this.props.params.slug}
        emailUrls={this.props.emailUrls}
      />
    )
  }
}

PostWrapper.propTypes = {
  maybeFetchPosts: PropTypes.func.isRequired,
  fetchPosts: PropTypes.func.isRequired,
  postSlug: PropTypes.string,
  emailUrls: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
  return {
    posts: getPosts(state),
  }
}

export default connect(mapStateToProps, { maybeFetchPosts, fetchPosts })(
  PostWrapper
)
